// React & third-party
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// UI components & helpers
import { forget_feed } from '../utils/ProductStruct.js';
import { forget_products } from '../utils/FeedStruct.js';
import Brand from '../components/splash/Brand';
import HelpFooter from '../components/HelpFooter';

// Styles
import '../assets/styles/splash.scss';

const Splash = ({ onConnect }) => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const handleConnect = () => {
		if (isLoading) return;
		setIsLoading(true);
		setTimeout(() => {
			navigate('/products');
		}, 1000 );
	};

  useEffect(() => {
    forget_products();
    forget_feed();
  }, [ ] );
  

	return (
		<div className="screen splash with-help-footer">
			<Brand variant="lg" align="center" />

			<section className="splash__hero">
				<h1 className="splash__title">
					Dove il <span className="gold">Reale</span><br />
					incontra il <span className="gold">Digitale</span>
				</h1>
			</section>

			<section className="splash__cta">
				<div className="splash__cta-text">
					<p>scansione la tessera</p>
					<p><span className="gold">accesso gekogold</span></p>
				</div>
				<button
                  type      = "button"
                  className = "splash__button"
                  onClick   = { handleConnect }
                  disabled  = { isLoading } >
			      Accedi
				</button>
			</section>

			<HelpFooter href="mailto:support@gekogold.com" target="_self" />
		</div>
	);
};

export default Splash;

